import { ExtendedValidationMessages } from 'commons/components';
import { TFunction } from 'core/i18n/i18n';
import type { PocInputValidity } from 'commons/types';
import { ErrorMapping } from 'core/types/error-mapping';
import {
    FIELD_ERROR_VALIDITY,
    areThresholdsValid,
    getMonitoringPeriodValidity,
    isMonitoringPeriodValid,
} from 'modules/settings/components/custom-notifications/custom-notification-form.validation';
import { OperatorCustomNotificationFormState } from 'modules/settings/pods/settings-operator-custom-notifications/settings-operator-custom-notification-form/settings-operator-custom-notification-form.model';
import { OPERATOR_CUSTOM_NOTIFICATION_FORM_I18N_PREFIX } from 'modules/settings/pods/settings-operator-custom-notifications/settings-operator-custom-notification-form/settings-operator-custom-notification-form.constants';

export interface OperatorCustomNotificationFormValidationMessages {
    name: ExtendedValidationMessages;
    triggers: ExtendedValidationMessages;
}

export const getOperatorCustomNotificationFormValidationMessages = (
    t: TFunction
): OperatorCustomNotificationFormValidationMessages => ({
    name: {
        error: {
            duplicated: t(`${OPERATOR_CUSTOM_NOTIFICATION_FORM_I18N_PREFIX}.name.error.duplicated`),
        },
    },
    triggers: {
        error: {
            custom: t(`${OPERATOR_CUSTOM_NOTIFICATION_FORM_I18N_PREFIX}.triggers.error.unavailable`),
        },
    },
});

export const getOperatorCustomNotificationFormValidation = (form: OperatorCustomNotificationFormState) => {
    const nameValid = form.name.trim().length > 0;
    const deviceTypesValid = form.deviceTypes.selectedIds.length > 0;
    const triggersValid = form.triggers.selectedIds.length > 0;
    const windowDaysValid = isMonitoringPeriodValid(form.windowDays);
    return {
        formValid:
            nameValid && deviceTypesValid && triggersValid && windowDaysValid && areThresholdsValid(form.notifications),
        windowDaysValidity: getMonitoringPeriodValidity(form.windowDays, false),
    };
};

export interface OperatorCustomNotificationFieldValidityInput {
    nameCustomValidationCode?: ErrorMapping['type'];
    hasUnavailableTriggers: boolean;
}

export interface OperatorCustomNotificationFieldValidity {
    name: PocInputValidity | undefined;
    triggers: PocInputValidity | undefined;
}

export const getServerRejectedFieldValidity = ({
    nameCustomValidationCode,
    hasUnavailableTriggers,
}: OperatorCustomNotificationFieldValidityInput): OperatorCustomNotificationFieldValidity => ({
    name: nameCustomValidationCode == null ? undefined : FIELD_ERROR_VALIDITY,
    triggers: hasUnavailableTriggers ? FIELD_ERROR_VALIDITY : undefined,
});
